// extracted by mini-css-extract-plugin
export var button = "_17-0";
export var buttonContent = "_17-e";
export var buttonGroup = "_17-c";
export var dontRestrainIconWidth = "_17-a";
export var dropdownButton = "_17-b";
export var iconContainer = "_17-9";
export var lg = "_17-4";
export var md = "_17-3";
export var pending = "_17-f";
export var sm = "_17-2";
export var spinner = "_17-d";
export var squared = "_17-8";
export var wrapText = "_17-g";
export var xl = "_17-5";
export var xs = "_17-1";
export var xxl = "_17-6";
export var xxxl = "_17-7";